export function groupBy<T>(array: T[], keyFn: (arg0: T) => string): Record<string, T[]> {
  return array.reduce((acc, value) => {
    const key = keyFn(value);

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(value);

    return acc;
  }, {} as Record<string, T[]>);
}

export function orderBy<T>(array: T[] | undefined, compareFn: (first: T, second: T) => number): T[] {
  if (!array) return [];
  return array.sort(compareFn);
}
